import { Client } from '@microsoft/microsoft-graph-client';
import { GRAPH_CLIENT_MIDDLEWARE_OPTIONS } from './GraphClientMiddlewareOptions'
import { LogEvents } from '../../utils/LogEvents';
import { ErrorStringFromException } from '../../utils/utils';
import { RetryServiceCallUntilSuccessOrTimeout } from '../Utils';

async function MakeGraphGetRequest(graphClient: Client, path: string) {
    return RetryServiceCallUntilSuccessOrTimeout(LogEvents.ServiceGraphOneDriveItem, 
        () =>
            graphClient.api(path)
            .middlewareOptions(GRAPH_CLIENT_MIDDLEWARE_OPTIONS)
            .get(),
        false /*shouldRetryOnNull*/,
        () => false /*shouldRetryError*/,  // Our graph ExceptionRetryHandler will retry fetch errors so no need to retry.
        () => true /*shouldIgnoreTimeout*/);
}

export async function MakeOneDriveItemGraphRequest(graphClient: Client, driveId: string, itemId: string) {
    LogEvents.ServiceGraphOneDriveItem.Start();
    try {
        const response = await MakeGraphGetRequest(graphClient, `/drives/${encodeURIComponent(driveId)}/items/${encodeURIComponent(itemId)}`);
        const message: string = (response == null)? "Error: response was null" : "Successfully received a response";
        LogEvents.ServiceGraphOneDriveItem.AddResponse({ isSuccessful: response != null, message: message, isFinalResponse: true });
        return response;
    } catch (e) {
        LogEvents.ServiceGraphOneDriveItem.AddResponse({ isSuccessful: false, message: "Error: " + ErrorStringFromException(e), isFinalResponse: true });
        throw e;
    }
}